// extracted by mini-css-extract-plugin
export default {"root":"SubView_root__w91yZ"};